import { ProgressHeaderWithPopup } from "../components/progressHeaderWithPopup"; // update path if needed
import { HeadLogo } from "../components/headLogo";
import { GameIntroHeader } from "../components/gameIntroHeader";
import { LocationImageDisplay } from "../components/locationImageDisplay";
import { CheckMoreButtons } from "../components/checkMoreButtons";
import { ModeIndication } from "../components/modeIndication";

function MindSnapView({
  mode,
  title,
  questionData,
  onAnswer,
  imageKey,
  answered,
  onComplete,
  currentStep,
  answerLabels,
  feedback
}) {
  const { question, options } = questionData;

  return (
    <div className="factFiction-layout">
      <HeadLogo />

      <ProgressHeaderWithPopup currentStep={currentStep} title={title} />
      <ModeIndication mode={mode} />
      <div className="global-screen-content">
        <GameIntroHeader title="MindSnap" description={question} />

        <div className="mindsnap-option-container">
          {options.map((option, idx) => (
            <div key={idx}>
              <button
                className="mindsnap-answer"
                id="answer-btn"
                style={
                  answered
                    ? {
                        backgroundColor:
                          option === questionData.correctAnswer
                            ? "#54C099"
                            : option === option
                            ? "#F1B6B6"
                            : "",
                      }
                    : {}
                }
                onClick={(e) => onAnswer(option, e.target)}
              >
                {answerLabels[idx]}. {option}
              </button>
            </div>
          ))}

          {answered && (
            <>
              <div className="mindsnap-comments">
                <div className="mindsnap-feedback">
                  {feedback}
                </div>
              </div>

              <CheckMoreButtons onNext={onComplete} />
            </>
          )}
        </div>
      </div>
      <LocationImageDisplay imageKey={imageKey} />
    </div>
  );
}

export { MindSnapView };
